(() => {
  const root = document.querySelector('[data-oe-free-product-request]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const dialog = root.querySelector('[data-oe-free-request-dialog]');
  const form = root.querySelector('form');
  const formView = root.querySelector('[data-oe-free-request-form-view]');
  const successView = root.querySelector('[data-oe-free-request-success]');
  const status = root.querySelector('[data-oe-free-request-status]');
  const closeButton = root.querySelector('[data-oe-free-request-close]');
  const brand = root.querySelector('[data-oe-free-request-brand]');
  const otherBrandField = root.querySelector('[data-oe-free-request-other-brand-field]');
  const otherBrand = root.querySelector('[data-oe-free-request-other-brand]');
  const firstName = root.querySelector('[data-oe-free-request-first-name]');
  const lastName = root.querySelector('[data-oe-free-request-last-name]');
  const model = root.querySelector('[data-oe-free-request-model]');
  const productUrl = root.querySelector('[data-oe-free-request-url]');
  const phone = root.querySelector('[data-oe-free-request-phone]');
  const message = root.querySelector('[data-oe-free-request-message]');
  const fullName = root.querySelector('[data-oe-free-request-full-name]');
  const body = root.querySelector('[data-oe-free-request-body]');
  const pendingKey = 'oe-free-product-request-pending';
  let lastOpener = null;
  let submitted = false;
  let previousOverflow;
  let previousBodyPaddingRight;
  let previousTriggerRight;
  let lastSubmitAt = -Infinity;

  const syncOtherBrand = () => {
    const selected = brand.value === 'Sonstige Marke';
    otherBrandField.hidden = !selected;
    otherBrand.disabled = !selected;
    otherBrand.required = selected;
    if (!selected) otherBrand.value = '';
  };

  const showError = (text) => {
    status.classList.remove('is-pending');
    status.textContent = text;
    status.hidden = false;
    window.requestAnimationFrame(() => status.focus());
  };
  const lockScroll = () => {
    const trigger = document.querySelector('[data-oe-contact-trigger]');
    previousOverflow = document.documentElement.style.overflow;
    previousBodyPaddingRight = document.body.style.paddingRight;
    previousTriggerRight = trigger?.style.right;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      const bodyPaddingRight = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.paddingRight = `${bodyPaddingRight + scrollbarWidth}px`;
      if (trigger) {
        const triggerRight = Number.parseFloat(window.getComputedStyle(trigger).right) || 0;
        trigger.style.right = `${triggerRight + scrollbarWidth}px`;
      }
    }
    document.documentElement.style.overflow = 'hidden';
  };
  const unlockScroll = () => {
    document.documentElement.style.overflow = previousOverflow;
    document.body.style.paddingRight = previousBodyPaddingRight;
    const trigger = document.querySelector('[data-oe-contact-trigger]');
    if (trigger) trigger.style.right = previousTriggerRight;
  };
  const showDialog = () => {
    if (dialog.open) return;
    lockScroll();
    root.classList.add('is-open');
    dialog.show();
    window.requestAnimationFrame(() => (submitted ? successView : closeButton).focus({ preventScroll: true }));
  };
  const showSuccess = () => {
    submitted = true;
    dialog.classList.add('is-success');
    form.reset();
    syncOtherBrand();
    status.hidden = true;
    formView.hidden = true;
    successView.hidden = false;
    showDialog();
  };
  const open = (opener) => {
    if (typeof dialog.show !== 'function') return;
    lastOpener = opener;
    if (submitted) {
      submitted = false;
      dialog.classList.remove('is-success');
      form.reset();
      syncOtherBrand();
      formView.hidden = false;
      successView.hidden = true;
    }
    status.hidden = true;
    showDialog();
  };

  brand.addEventListener('change', syncOtherBrand);
  window.addEventListener('oe:free-product-request:open', (event) => open(event.detail?.opener));
  closeButton.addEventListener('click', () => dialog.close());
  root.addEventListener('click', (event) => {
    if (event.target === root) dialog.close();
  });
  dialog.addEventListener('close', () => {
    root.classList.remove('is-open');
    unlockScroll();
    lastOpener?.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', (event) => {
    if (!dialog.open) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      dialog.close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')]
      .filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  const currentUrl = new URL(window.location.href);
  let nativeSubmissionPending = false;
  try { nativeSubmissionPending = window.sessionStorage.getItem(pendingKey) === 'true'; } catch (error) {}
  if (currentUrl.searchParams.get('free_product_request') === 'success' && nativeSubmissionPending) {
    try { window.sessionStorage.removeItem(pendingKey); } catch (error) {}
    currentUrl.searchParams.delete('free_product_request');
    window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    showSuccess();
  }

  form.addEventListener('invalid', () => {
    showError('Bitte füllen Sie alle Pflichtfelder aus und prüfen Sie Ihre Angaben.');
  }, true);
  form.addEventListener('submit', (event) => {
    const now = window.performance.now();
    if (now - lastSubmitAt < 4000) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    lastSubmitAt = now;
    status.hidden = true;
    const requestedBrand = brand.value === 'Sonstige Marke' ? otherBrand.value.trim() : brand.value;
    fullName.value = `${firstName.value.trim()} ${lastName.value.trim()}`;
    body.value = [
      `Marke: ${requestedBrand}`,
      `Modell / Produktbezeichnung: ${model.value.trim()}`,
      `Produktlink: ${productUrl.value.trim() || 'Nicht angegeben'}`,
      `Telefonnummer: ${phone.value.trim() || 'Nicht angegeben'}`,
      `Nachricht / weitere Angaben: ${message.value.trim() || 'Keine'}`,
    ].join('\n');
    try { window.sessionStorage.setItem(pendingKey, 'true'); } catch (error) {}
    // Shopify handles CAPTCHA, delivery and the redirect as on the contact page.
  }, true);
})();
